module.exports = __webpack_public_path__ + "img/bg_stage1.e3468a24.png";